/*jshint esversion: 6 */
'use strict';

class Util {
	static addClass(elements = null, className) {
		if (elements === null) {
			return;
		}

		let add = function(element, className) {
			if (element.classList) {
				element.classList.add(className);
			} else {
				element.className += ` ${className}`;
			}
		};

		if (typeof elements.length === 'undefined') {
			add(elements, className);
		} else {
			for (let i = 0, l = elements.length; i < l; i++) {
				add(elements[i], className);
			}
		}
	}

	static removeClass(elements = null, className) {
		if (elements === null) {
			return;
		}

		let remove = function(element, className) {
			if (element.classList) {
				element.classList.remove(className);
			} else {
				element.className = element.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, `gi`), ' ').trim();
			}
		};

		if (typeof elements.length === 'undefined') {
			remove(elements, className);
		} else {
			for (let i = 0, l = elements.length; i < l; i++) {
				remove(elements[i], className);
			}
		}
	}

	static hasClass(element, className) {
		if (!element) {
			return;
		}

		if (element.classList) {
			return element.classList.contains(className);
		} else {
			return new RegExp(`(^| )${className}( |$)`, `gi`).test(element.className);
		}
	}

	static toggleClass(element, className) {
		if (Util.hasClass(element, className)) {
			Util.removeClass(element, className);
		} else {
			Util.addClass(element, className);
		}
	}

	static closest(element, tagName) {
		while (element.tagName !== tagName) {
			element = element.parentNode;
		}

		return element;
	}

	static scrollTo(target, options) {
		let start = window.pageYOffset,
			easeInOutQuad = function(t, b, c, d) {
				t /= d / 2
				if (t < 1) {
					return c / 2 * t * t + b
				}
				t--
				return -c / 2 * (t * (t - 2) - 1) + b
			},
			loop = function(time) {
				timeElapsed = time - timeStart;

				window.scrollTo(0, opt.easing(timeElapsed, start, distance, duration));

				if (timeElapsed < duration) {
					requestAnimationFrame(loop)
				} else {
					end();
				}
			},
			end = function() {
				window.scrollTo(0, start + distance);

				if (typeof opt.callback === 'function') {
					opt.callback();
				}
			},
			opt = {
				duration: options.duration,
				offset: options.offset || 0,
				callback: options.callback,
				easing: easeInOutQuad
			},
			distance = typeof target === 'string' ? opt.offset + document.querySelector(target).getBoundingClientRect().top : target,
			duration = typeof opt.duration === 'function' ? opt.duration(distance) : opt.duration,
			timeStart, timeElapsed;

		requestAnimationFrame(function(time) {
			timeStart = time;
			loop(time);
		});
	}

	static isVisible(element, tolerance) {
		if (!element || 1 !== element.nodeType) {
			return false;
		}

		tolerance = tolerance || 0;

		var html = document.documentElement,
			r = element.getBoundingClientRect(),
			h = html.clientHeight,
			w = html.clientWidth;

		if (!!r && (r.bottom - tolerance) >= 0 && r.right >= 0 && (r.top - tolerance) <= h && r.left <= w) {
			return true;
		} else {
			return false;
		}
	}

	static addEventListener(el, eventName, handler) {
		el.forEach && el.forEach((el, i) => {
			
			if (el.addEventListener) {
				el.addEventListener(eventName, handler);
			} else {
				el.attachEvent('on' + eventName, function(){
					handler.call(el);
				});
			}
		});

		if (! el.forEach) {
			if (el.addEventListener) {
				for (let i = 0; i < eventName.length; i++) {
					el.addEventListener(eventName[i], handler);
				}
			} else {
				el.attachEvent('on' + eventName, function(){
					handler.call(el);
				});
			}
		}
	}
}

export default Util;



// WEBPACK FOOTER //
// ./httpdocs/grandclassics/themes/wppt/assets/src/js/classes/Util.js